import React from 'react';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { useFetchWithStatus } from 'hooks/fetchWithStatus';
import { FPIconButton } from 'UI/components/atoms';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import HistoryItem from 'UI/components/molecules/HistoryItem';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { buildCloseAndGoBackDefinition } from 'UI/components/templates/FPDrawer/FPDrawer.constants';
import { TypeHistoryItem } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';
import { EmptySendouts, SvgArrowLeft } from 'UI/res';
import { getId } from 'UI/utils';
import { renderSmartTags } from 'UI/utils/sendouts';

import { prepareArrayToDeclinationDetails } from '../utils';

/**
 * @param {Object} props
 * @param {number} props.id
 * @param {string} props.title
 * @param {Function} props.onClose
 * @param {Function} props.onBack
 */
const SendoutEventLogsSection = ({ id, title, onClose, onBack }) => {
  const endpoint = `${Endpoints.SendoutsLogs.replace(':id', id)}`;
  const { Status } = useFetchWithStatus(endpoint);

  const buttonDefinitions = buildCloseAndGoBackDefinition({ onClose, onGoBack: onBack });

  return (
    <FPDrawer
      FPDrawerProps={{ open: true, onClose }}
      CardHeaderProps={{
        title,
        titleTypographyProps: {
          variant: 'h5'
        },
        avatar: (
          <FPIconButton
            onClick={onBack}
            iconMode="custom"
            icon={SvgArrowLeft}
            tooltipProps={{ title: 'Back' }}
          />
        )
      }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <>
        <Typography variant="subtitle1" gutterBottom>
          Activity log:
        </Typography>
        <Status
          loading={
            <List dense>
              <HistoryItem isLoading />
            </List>
          }
          empty={
            <Typography paragraph gutterBottom>
              No activity yet
            </Typography>
          }
          error={error => (
            <EmptyPlaceholder title="Oops" subtitle={error} customEmptyState={<EmptySendouts />} />
          )}
          success={results => (
            <List dense>
              {results.map(log => (
                <HistoryItem
                  key={log.id || getId()}
                  date={log.real_date}
                  type={TypeHistoryItem.Sendout}
                  action={renderSmartTags(log)}
                  extraData={prepareArrayToDeclinationDetails(log?.event_details)}
                />
              ))}
            </List>
          )}
        />
      </>
    </FPDrawer>
  );
};

export default SendoutEventLogsSection;
